import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum SlideStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

interface InvestorReportState {
  slideStatus: Record<string, SlideStatus>;
}

const initialState: InvestorReportState = {
  slideStatus: {},
};

const InvestorReport = createSlice({
  name: 'InvestorReport',
  initialState,
  reducers: {
    lockSlide: (state: InvestorReportState, action: PayloadAction<string>) => {
      state.slideStatus[action.payload] = SlideStatus.IN_PROGRESS;
    },

    unlockSlide: (state: InvestorReportState, action: PayloadAction<string>) => {
      state.slideStatus[action.payload] = SlideStatus.COMPLETED;
    },

    initializeSlideStatus: (
      state: InvestorReportState,
      action: PayloadAction<{ lockedSlideIds: string[]; unlockedSlideIds: string[] }>,
    ) => {
      state.slideStatus = {};

      action.payload.lockedSlideIds.forEach((slideId) => {
        state.slideStatus[slideId] = SlideStatus.IN_PROGRESS;
      });

      action.payload.unlockedSlideIds.forEach((slideId) => {
        state.slideStatus[slideId] = SlideStatus.COMPLETED;
      });
    },

    resetSlideStatus: (state: InvestorReportState) => {
      state.slideStatus = {};
    },

    mergeSlideStatus: (
      state: InvestorReportState,
      action: PayloadAction<{ lockedSlideIds: string[]; unlockedSlideIds: string[] }>,
    ) => {
      action.payload.lockedSlideIds.forEach((slideId) => {
        state.slideStatus[slideId] = SlideStatus.IN_PROGRESS;
      });
      action.payload.unlockedSlideIds.forEach((slideId) => {
        state.slideStatus[slideId] = SlideStatus.COMPLETED;
      });
    },

    updateSlideStatus: (
      state: InvestorReportState,
      action: PayloadAction<{ key: string; status: SlideStatus }>,
    ) => {
      state.slideStatus[action.payload.key] = action.payload.status;
    },
  },
});

export const {
  lockSlide,
  unlockSlide,
  initializeSlideStatus,
  resetSlideStatus,
  mergeSlideStatus,
  updateSlideStatus,
} = InvestorReport.actions;
export default InvestorReport.reducer;
